/**
 * Literales de UI de la vista Marketing (marketing.js + marketing-cupones.js).
 * Clave = texto español EXACTO tal como aparece en el código (estilo gettext).
 * Los globales (Guardar, Cancelar, Editar, Eliminar, Crear, Activo, Inactivo…)
 * viven en diccionario-comunes.js y NO se re-declaran acá.
 *
 * Terminología pt-BR canónica del proyecto: promoção, cupom, campanha, bônus,
 * indicação (referido), cashback, sorteio, aposta, modelo (plantilla).
 */

export const DICCIONARIO_MARKETING = {
    // ── Encabezados de tabla / data-labels ──────────────────────────────────
    Trigger: { pt: 'Gatilho', en: 'Trigger', ru: 'Триггер' },
    Recompensa: { pt: 'Recompensa', en: 'Reward', ru: 'Награда' },
    Usos: { pt: 'Usos', en: 'Uses', ru: 'Использования' },
    Promocion: { pt: 'Promoção', en: 'Promotion', ru: 'Акция' },
    Categoria: { pt: 'Categoria', en: 'Category', ru: 'Категория' },
    Autor: { pt: 'Autor', en: 'Author', ru: 'Автор' },
    'Promos recibidas': { pt: 'Promos recebidas', en: 'Promos received', ru: 'Полученные акции' },
    'Total recompensas': { pt: 'Total de recompensas', en: 'Total rewards', ru: 'Всего наград' },
    'Ultima promo': { pt: 'Última promo', en: 'Last promo', ru: 'Последняя акция' },
    'Fecha registro': { pt: 'Data de cadastro', en: 'Registration date', ru: 'Дата регистрации' },
    'Total apostado': { pt: 'Total apostado', en: 'Total wagered', ru: 'Всего поставлено' },
    Recibidas: { pt: 'Recebidas', en: 'Received', ru: 'Получено' },
    Ultima: { pt: 'Última', en: 'Last', ru: 'Последняя' },

    // ── Estados y botones ───────────────────────────────────────────────────
    Clonar: { pt: 'Clonar', en: 'Clone', ru: 'Клонировать' },
    Usar: { pt: 'Usar', en: 'Use', ru: 'Использовать' },
    'Marcar Influencer': { pt: 'Marcar Influencer', en: 'Mark as Influencer', ru: 'Отметить как инфлюенсера' },

    // ── Mensajes de carga / vacíos ──────────────────────────────────────────
    'Sin referidos': { pt: 'Sem indicações', en: 'No referrals', ru: 'Нет рефералов' },
    'El jugador apostó en varias monedas: no existe un total único': {
        pt: 'O jogador apostou em várias moedas: não existe um total único',
        en: 'The player bet in several currencies: there is no single total',
        ru: 'Игрок делал ставки в нескольких валютах: единой суммы не существует',
    },
    'Cliente no encontrado': { pt: 'Cliente não encontrado', en: 'Customer not found', ru: 'Клиент не найден' },
    'No hay promociones creadas. Usa el boton "Nueva Promocion" o activa una plantilla.': {
        pt: 'Não há promoções criadas. Use o botão "Nova Promoção" ou ative um modelo.',
        en: 'No promotions created. Use the "New Promotion" button or activate a template.',
        ru: 'Нет созданных акций. Нажмите кнопку «Новая акция» или активируйте шаблон.',
    },
    'No hay plantillas disponibles': {
        pt: 'Não há modelos disponíveis',
        en: 'No templates available',
        ru: 'Нет доступных шаблонов',
    },
    'No hay plantillas disponibles. Crea una primero.': {
        pt: 'Não há modelos disponíveis. Crie um primeiro.',
        en: 'No templates available. Create one first.',
        ru: 'Нет доступных шаблонов. Сначала создайте один.',
    },

    // ── Errores y toasts ────────────────────────────────────────────────────
    'Error al cargar promociones': {
        pt: 'Erro ao carregar promoções',
        en: 'Error loading promotions',
        ru: 'Ошибка загрузки акций',
    },
    'Error al cargar plantillas': {
        pt: 'Erro ao carregar modelos',
        en: 'Error loading templates',
        ru: 'Ошибка загрузки шаблонов',
    },
    'Error al buscar': { pt: 'Erro ao buscar', en: 'Search error', ru: 'Ошибка поиска' },
    'Error al cambiar estado': {
        pt: 'Erro ao alterar o status',
        en: 'Error changing status',
        ru: 'Ошибка изменения статуса',
    },
    'Error al eliminar promocion': {
        pt: 'Erro ao excluir a promoção',
        en: 'Error deleting promotion',
        ru: 'Ошибка удаления акции',
    },
    'Error al cargar la promocion': {
        pt: 'Erro ao carregar a promoção',
        en: 'Error loading the promotion',
        ru: 'Ошибка загрузки акции',
    },
    'Error al marcar como influencer': {
        pt: 'Erro ao marcar como influencer',
        en: 'Error marking as influencer',
        ru: 'Ошибка отметки как инфлюенсера',
    },
    'Plantilla actualizada': { pt: 'Modelo atualizado', en: 'Template updated', ru: 'Шаблон обновлён' },
    'Plantilla creada': { pt: 'Modelo criado', en: 'Template created', ru: 'Шаблон создан' },
    'Promocion actualizada': { pt: 'Promoção atualizada', en: 'Promotion updated', ru: 'Акция обновлена' },
    'Promocion creada': { pt: 'Promoção criada', en: 'Promotion created', ru: 'Акция создана' },
    Plantilla: { pt: 'Modelo', en: 'Template', ru: 'Шаблон' },
    eliminada: { pt: 'excluído', en: 'deleted', ru: 'удалена' },
    '¿Eliminar plantilla': { pt: 'Excluir o modelo', en: 'Delete template', ru: 'Удалить шаблон' },
    'Eliminar la promocion': { pt: 'Excluir a promoção', en: 'Delete the promotion', ru: 'Удалить акцию' },
    'Marcar este cliente como influencer?': {
        pt: 'Marcar este cliente como influencer?',
        en: 'Mark this customer as an influencer?',
        ru: 'Отметить этого клиента как инфлюенсера?',
    },

    // ── Títulos y botones del modal de promoción ────────────────────────────
    'Nueva Promocion (Scoped)': {
        pt: 'Nova Promoção (com escopo)',
        en: 'New Promotion (Scoped)',
        ru: 'Новая акция (с областью)',
    },
    'Editar Promocion': { pt: 'Editar Promoção', en: 'Edit Promotion', ru: 'Редактировать акцию' },
    'Nueva Plantilla': { pt: 'Novo Modelo', en: 'New Template', ru: 'Новый шаблон' },
    'Editar Plantilla': { pt: 'Editar Modelo', en: 'Edit Template', ru: 'Редактировать шаблон' },
    'Crear Plantilla': { pt: 'Criar Modelo', en: 'Create Template', ru: 'Создать шаблон' },
    'Guardar Plantilla': { pt: 'Salvar Modelo', en: 'Save Template', ru: 'Сохранить шаблон' },
    'Elegir Plantilla': { pt: 'Escolher Modelo', en: 'Choose Template', ru: 'Выбрать шаблон' },

    // ── Audiencias de la promoción (dónde puede activarse) ───────────────────
    'Puede activarse en': { pt: 'Pode ser ativada em', en: 'Can be activated on', ru: 'Можно активировать в' },
    'Jugador identificado en la web': {
        pt: 'Jogador identificado na web',
        en: 'Player identified on the web',
        ru: 'Игрок, идентифицированный в вебе',
    },
    'Jugador identificado por el launch': {
        pt: 'Jogador identificado pelo launch',
        en: 'Player identified by the launch',
        ru: 'Игрок, идентифицированный через launch',
    },
    'Jugador identificado en la terminal': {
        pt: 'Jogador identificado no terminal',
        en: 'Player identified at the terminal',
        ru: 'Игрок, идентифицированный на терминале',
    },
    'Turno anónimo de la terminal': {
        pt: 'Turno anônimo do terminal',
        en: 'Anonymous terminal session',
        ru: 'Анонимная смена терминала',
    },
    'VLT · jugador': { pt: 'VLT · jogador', en: 'VLT · player', ru: 'VLT · игрок' },
    'VLT · turno': { pt: 'VLT · turno', en: 'VLT · session', ru: 'VLT · смена' },
    'El punto de venta y su herencia se configuran en Alcance; aquí no se duplican.': {
        pt: 'O ponto de venda e sua herança são configurados em Alcance; aqui não se duplicam.',
        en: 'The point of sale and its inheritance are configured in Scope; they are not duplicated here.',
        ru: 'Точка продажи и её наследование настраиваются в «Охват»; здесь они не дублируются.',
    },

    // ── Capacidad financiera: por qué una promoción queda en borrador ────────
    'Se guardará como borrador: todavía no se puede activar': {
        pt: 'Será salva como rascunho: ainda não pode ser ativada',
        en: 'It will be saved as a draft: it cannot be activated yet',
        ru: 'Будет сохранено как черновик: пока нельзя активировать',
    },
    'No se puede activar todavía: revise el motivo en el formulario': {
        pt: 'Ainda não pode ser ativada: veja o motivo no formulário',
        en: 'Cannot be activated yet: check the reason in the form',
        ru: 'Пока нельзя активировать: смотрите причину в форме',
    },
    'Reglas que este editor no muestra: se guardan tal cual, sin cambios': {
        pt: 'Regras que este editor não mostra: são salvas como estão, sem alterações',
        en: 'Rules this editor does not show: they are saved as they are, unchanged',
        ru: 'Правила, которые этот редактор не показывает: сохраняются как есть, без изменений',
    },
    'Las no admitidas usan un campo que el sistema ya no calcula: la promoción no puede activarse hasta revisarlas.': {
        pt: 'As não admitidas usam um campo que o sistema não calcula mais: a promoção não pode ser ativada até revisá-las.',
        en: 'The unsupported ones use a field the system no longer computes: the promotion cannot be activated until they are reviewed.',
        ru: 'Неподдерживаемые используют поле, которое система больше не вычисляет: акцию нельзя активировать, пока их не проверят.',
    },
    'Se conserva sin editar': { pt: 'Mantida sem editar', en: 'Kept unedited', ru: 'Сохранено без изменений' },
    'No admitida': { pt: 'Não admitida', en: 'Unsupported', ru: 'Не поддерживается' },
    Hito: { pt: 'Marco', en: 'Milestone', ru: 'Этап' },
    Condición: { pt: 'Condição', en: 'Condition', ru: 'Условие' },
    'No se puede activar todavía:': {
        pt: 'Ainda não pode ser ativada:',
        en: 'Cannot be activated yet:',
        ru: 'Пока нельзя активировать:',
    },
    'Esta recompensa no está ofrecida para jugadores B2B: no tiene una custodia de pago acordada con el integrador.': {
        pt: 'Esta recompensa não é oferecida para jogadores B2B: não tem uma custódia de pagamento acordada com o integrador.',
        en: 'This reward is not offered for B2B players: it has no payment custody agreed with the integrator.',
        ru: 'Это вознаграждение не предлагается игрокам B2B: для него нет согласованной с интегратором схемы выплаты.',
    },
    'Una apuesta gratis B2B necesita objetivo de apuestas (wagering): sin él, el jugador no tiene cómo cerrarla desde su superficie.':
        {
            pt: 'Uma aposta grátis B2B precisa de meta de apostas (wagering): sem ela, o jogador não tem como encerrá-la pela sua superfície.',
            en: 'A B2B free bet needs a wagering target: without it, the player has no way to close it from their surface.',
            ru: 'Бесплатная ставка B2B требует цели отыгрыша (wagering): без неё игрок не сможет закрыть её со своей поверхности.',
        },
    'Los premios B2B se pagan en la wallet del integrador: ese disparador no llega al motor.': {
        pt: 'Os prêmios B2B são pagos na carteira do integrador: esse gatilho não chega ao motor.',
        en: 'B2B prizes are paid in the integrator wallet: that trigger never reaches the engine.',
        ru: 'Призы B2B выплачиваются в кошельке интегратора: этот триггер не доходит до движка.',
    },
    'El jugador B2B no se registra acá (nace del integrador): ese disparador no ocurre.': {
        pt: 'O jogador B2B não se registra aqui (nasce do integrador): esse gatilho não ocorre.',
        en: 'The B2B player does not register here (they come from the integrator): that trigger never happens.',
        ru: 'Игрок B2B здесь не регистрируется (он приходит от интегратора): этот триггер не происходит.',
    },
    'El jugador B2B no deposita acá (su saldo vive en el integrador): ese disparador no ocurre.': {
        pt: 'O jogador B2B não deposita aqui (seu saldo fica no integrador): esse gatilho não ocorre.',
        en: 'The B2B player does not deposit here (their balance lives at the integrator): that trigger never happens.',
        ru: 'Игрок B2B здесь не пополняет счёт (его баланс у интегратора): этот триггер не происходит.',
    },
    'El jugador B2B no entra por links de referido: ese disparador no ocurre.': {
        pt: 'O jogador B2B não entra por links de indicação: esse gatilho não ocorre.',
        en: 'The B2B player does not arrive via referral links: that trigger never happens.',
        ru: 'Игрок B2B не приходит по реферальным ссылкам: этот триггер не происходит.',
    },
    'El jugador B2B juega dentro del sitio del integrador, sin app propia.': {
        pt: 'O jogador B2B joga dentro do site do integrador, sem app próprio.',
        en: 'The B2B player plays inside the integrator site, with no app of their own.',
        ru: 'Игрок B2B играет на сайте интегратора, без собственного приложения.',
    },
    'El jugador B2B no genera recargas acá: ese disparador no ocurre.': {
        pt: 'O jogador B2B não gera recargas aqui: esse gatilho não ocorre.',
        en: 'The B2B player does not create top-ups here: that trigger never happens.',
        ru: 'Игрок B2B здесь не создаёт пополнений: этот триггер не происходит.',
    },
    'Ese disparador no está producido para la superficie B2B.': {
        pt: 'Esse gatilho não é produzido para a superfície B2B.',
        en: 'That trigger is not produced for the B2B surface.',
        ru: 'Этот триггер не производится для поверхности B2B.',
    },
    'Un bonus de registro para B2B necesita un presupuesto total positivo: sin tope, cada alta paga sin límite.': {
        pt: 'Um bônus de registro para B2B precisa de um orçamento total positivo: sem teto, cada cadastro paga sem limite.',
        en: 'A B2B registration bonus needs a positive total budget: without a cap, every signup pays without limit.',
        ru: 'Бонус за регистрацию B2B требует положительного общего бюджета: без лимита каждая регистрация платит без ограничений.',
    },
    'Este disparador todavía no tiene quién lo produzca de forma confiable: no se puede activar para nadie.': {
        pt: 'Esse gatilho ainda não tem quem o produza de forma confiável: não pode ser ativado para ninguém.',
        en: 'This trigger still has no reliable producer: it cannot be activated for anyone.',
        ru: 'У этого триггера пока нет надёжного источника событий: его нельзя активировать ни для кого.',
    },
    'Este disparador todavía no tiene quién lo produzca: no se puede activar para nadie.': {
        pt: 'Esse gatilho ainda não tem quem o produza: não pode ser ativado para ninguém.',
        en: 'This trigger still has no producer: it cannot be activated for anyone.',
        ru: 'У этого триггера пока нет источника событий: его нельзя активировать ни для кого.',
    },
    'Una visita con recompensa monetaria se dispara con cada canje: necesita un límite de usos por cliente.': {
        pt: 'Uma visita com recompensa monetária dispara a cada resgate de sessão: precisa de um limite de usos por cliente.',
        en: 'A visit with a monetary reward fires on every session redemption: it needs a cap on uses per customer.',
        ru: 'Визит с денежной наградой срабатывает при каждом входе: нужен лимит использований на клиента.',
    },
    'Las visitas solo existen para jugadores B2B.': {
        pt: 'As visitas só existem para jogadores B2B.',
        en: 'Visits only exist for B2B players.',
        ru: 'Визиты существуют только для игроков B2B.',
    },
    'Visita con recompensa monetaria: obligatorio. Cada canje la dispara; sin límite no se activa.': {
        pt: 'Visita com recompensa monetária: obrigatório. Cada resgate a dispara; sem limite não é ativada.',
        en: 'Visit with a monetary reward: required. Every redemption fires it; without a cap it will not activate.',
        ru: 'Визит с денежной наградой: обязательно. Каждый вход его запускает; без лимита акция не активируется.',
    },
    'Guardada como borrador: todavía no se puede activar': {
        pt: 'Salva como rascunho: ainda não pode ser ativada',
        en: 'Saved as a draft: it cannot be activated yet',
        ru: 'Сохранено как черновик: пока нельзя активировать',
    },
    'El límite de usos por cliente debe ser un entero mayor que 0': {
        pt: 'O limite de usos por cliente deve ser um inteiro maior que 0',
        en: 'The per-customer use limit must be an integer greater than 0',
        ru: 'Лимит использований на клиента должен быть целым числом больше 0',
    },
    'El barrido periódico paga cada hora a cada cliente: necesita un tope de usos por cliente.': {
        pt: 'A varredura periódica paga toda hora a cada cliente: precisa de um limite de usos por cliente.',
        en: 'The periodic sweep pays every hour to every customer: it needs a cap on uses per customer.',
        ru: 'Периодическая проверка платит каждому клиенту каждый час: нужен лимит использований на клиента.',
    },
    'El barrido periódico paga cada hora: el cashback necesita su cooldown de un pago por día.': {
        pt: 'A varredura periódica paga toda hora: o cashback precisa do seu cooldown de um pagamento por dia.',
        en: 'The periodic sweep pays every hour: cashback needs its cooldown of one payment per day.',
        ru: 'Периодическая проверка платит каждый час: для кешбэка нужен кулдаун — одна выплата в день.',
    },
    'El turno VLT no puede ejecutar esta configuración con el mismo significado que el motor Customer.': {
        pt: 'O turno VLT não pode executar esta configuração com o mesmo significado que o motor Customer.',
        en: 'The VLT session cannot execute this configuration with the same meaning as the Customer engine.',
        ru: 'Смена VLT не может выполнить эту конфигурацию с тем же смыслом, что и движок Customer.',
    },
    'El turno VLT todavía no tiene quién produzca y pague un bonus directo.': {
        pt: 'O turno VLT ainda não tem quem produza e pague um bônus direto.',
        en: 'The VLT session still has no producer to pay a direct bonus.',
        ru: 'У смены VLT пока нет производителя для прямой выплаты бонуса.',
    },
    'El turno VLT todavía no tiene adaptador para apuestas gratis.': {
        pt: 'O turno VLT ainda não tem adaptador para apostas grátis.',
        en: 'The VLT session has no free bet adapter yet.',
        ru: 'У смены VLT пока нет адаптера для бесплатных ставок.',
    },
    'El turno VLT todavía no tiene adaptador para activar el filón.': {
        pt: 'O turno VLT ainda não tem adaptador para ativar o filão.',
        en: 'The VLT session has no adapter to activate the vein bonus yet.',
        ru: 'У смены VLT пока нет адаптера для активации «жилы».',
    },
    'La terminal todavía no tiene canal para presentarle una notificación al turno anónimo.': {
        pt: 'O terminal ainda não tem canal para apresentar uma notificação ao turno anônimo.',
        en: 'The terminal has no channel yet to present a notification to the anonymous session.',
        ru: 'У терминала пока нет канала для показа уведомления анонимной смене.',
    },
    'El turno anónimo de la terminal VLT todavía no tiene con qué disparar ni pagar una recompensa.': {
        pt: 'O turno anônimo do terminal VLT ainda não tem como disparar nem pagar uma recompensa.',
        en: 'The anonymous VLT terminal session still has no way to trigger or pay a reward.',
        ru: 'Анонимная смена терминала VLT пока не может ни запустить, ни выплатить вознаграждение.',
    },
    'Las recompensas multinivel y de equipo todavía no tienen quién las pague.': {
        pt: 'As recompensas multinível e de equipe ainda não têm quem as pague.',
        en: 'Multilevel and team rewards still have no one to pay them.',
        ru: 'Многоуровневые и командные вознаграждения пока некому выплачивать.',
    },
    'El sistema no reconoce ese tipo de recompensa, así que no puede pagarla.': {
        pt: 'O sistema não reconhece esse tipo de recompensa, então não pode pagá-la.',
        en: 'The system does not recognize that reward type, so it cannot pay it.',
        ru: 'Система не распознаёт этот тип вознаграждения, поэтому не может его выплатить.',
    },
    'La configuración de recompensas o de hitos no se puede leer, así que no se puede comprobar que pague.': {
        pt: 'A configuração de recompensas ou de marcos não pode ser lida, então não dá para comprovar que paga.',
        en: 'The rewards or milestones configuration cannot be read, so payment cannot be verified.',
        ru: 'Конфигурацию вознаграждений или этапов невозможно прочитать, поэтому выплату нельзя проверить.',
    },
    'El sistema todavía no puede pagar esta combinación.': {
        pt: 'O sistema ainda não pode pagar esta combinação.',
        en: 'The system cannot pay this combination yet.',
        ru: 'Система пока не может оплатить эту комбинацию.',
    },
    'Activar Plantilla:': { pt: 'Ativar Modelo:', en: 'Activate Template:', ru: 'Активировать шаблон:' },
    'Nueva Plantilla (desde:': { pt: 'Novo Modelo (a partir de:', en: 'New Template (from:', ru: 'Новый шаблон (из:' },
    copia: { pt: 'cópia', en: 'copy', ru: 'копия' },

    // ── Formulario y builder ────────────────────────────────────────────────
    'Nombre es obligatorio': { pt: 'Nome é obrigatório', en: 'Name is required', ru: 'Имя обязательно' },
    'Selecciona cuando se activa la promocion': {
        pt: 'Selecione quando a promoção é ativada',
        en: 'Select when the promotion is activated',
        ru: 'Выберите, когда активируется акция',
    },
    'Selecciona un tipo de recompensa': {
        pt: 'Selecione um tipo de recompensa',
        en: 'Select a reward type',
        ru: 'Выберите тип награды',
    },
    Valor: { pt: 'Valor', en: 'Value', ru: 'Значение' },
    '≤ Monto evento': { pt: '≤ Valor do evento', en: '≤ Event amount', ru: '≤ Сумма события' },
    '+ Agregar nivel': { pt: '+ Adicionar nível', en: '+ Add level', ru: '+ Добавить уровень' },
    Maximo: { pt: 'Máximo', en: 'Maximum', ru: 'Максимум' },
    niveles: { pt: 'níveis', en: 'levels', ru: 'уровни' },
    'Perdida hasta': { pt: 'Perda até', en: 'Loss up to', ru: 'Проигрыш до' },
    'Vacio = sin techo': { pt: 'Vazio = sem teto', en: 'Empty = no cap', ru: 'Пусто = без лимита' },
    'ID (ej: bronce)': { pt: 'ID (ex: bronze)', en: 'ID (e.g.: bronze)', ru: 'ID (напр.: бронза)' },
    'Meta:': { pt: 'Meta:', en: 'Goal:', ru: 'Цель:' },
    'Recompensa:': { pt: 'Recompensa:', en: 'Reward:', ru: 'Награда:' },
    '(sin acceso)': { pt: '(sem acesso)', en: '(no access)', ru: '(нет доступа)' },
    'Codigo:': { pt: 'Código:', en: 'Code:', ru: 'Код:' },

    // ── Placeholders del buscador ───────────────────────────────────────────
    'Buscar por telefono, nombre o promocion...': {
        pt: 'Buscar por telefone, nome ou promoção...',
        en: 'Search by phone, name or promotion...',
        ru: 'Поиск по телефону, имени или акции...',
    },
    'Buscar por nombre o codigo...': {
        pt: 'Buscar por nome ou código...',
        en: 'Search by name or code...',
        ru: 'Поиск по имени или коду...',
    },
    'Buscar por nombre, codigo o categoria...': {
        pt: 'Buscar por nome, código ou categoria...',
        en: 'Search by name, code or category...',
        ru: 'Поиск по имени, коду или категории...',
    },
    'Buscar por telefono o nombre...': {
        pt: 'Buscar por telefone ou nome...',
        en: 'Search by phone or name...',
        ru: 'Поиск по телефону или имени...',
    },
    'Buscar por telefono...': { pt: 'Buscar por telefone...', en: 'Search by phone...', ru: 'Поиск по телефону...' },

    // ── Resumen de recompensas ──────────────────────────────────────────────
    'Solo hitos': { pt: 'Apenas marcos', en: 'Milestones only', ru: 'Только вехи' },
    max: { pt: 'máx', en: 'max', ru: 'макс' },
    'Cashback por niveles': { pt: 'Cashback por níveis', en: 'Cashback by levels', ru: 'Кэшбэк по уровням' },
    Cashback: { pt: 'Cashback', en: 'Cashback', ru: 'Кэшбэк' },
    'Apuesta gratis': { pt: 'Aposta grátis', en: 'Free bet', ru: 'Бесплатная ставка' },
    Filon: { pt: 'Filão', en: 'Goldmine', ru: 'Золотая жила' },
    Notificacion: { pt: 'Notificação', en: 'Notification', ru: 'Уведомление' },
    Multinivel: { pt: 'Multinível', en: 'Multi-level', ru: 'Многоуровневый' },
    Equipo: { pt: 'Equipe', en: 'Team', ru: 'Команда' },

    // ── Cupones ─────────────────────────────────────────────────────────────
    'Campañas de Cupones': { pt: 'Campanhas de Cupons', en: 'Coupon Campaigns', ru: 'Купонные кампании' },
    Código: { pt: 'Código', en: 'Code', ru: 'Код' },
    'Emitidos / Total': { pt: 'Emitidos / Total', en: 'Issued / Total', ru: 'Выпущено / Всего' },
    Canjeados: { pt: 'Resgatados', en: 'Redeemed', ru: 'Погашено' },
    'Nueva campaña': { pt: 'Nova campanha', en: 'New campaign', ru: 'Новая кампания' },
    'No hay campañas de cupones. Crea una con el botón "Nueva campaña" para empezar a emitir.': {
        pt: 'Não há campanhas de cupons. Crie uma com o botão "Nova campanha" para começar a emitir.',
        en: 'No coupon campaigns. Create one with the "New campaign" button to start issuing.',
        ru: 'Нет купонных кампаний. Создайте одну с помощью кнопки «Новая кампания», чтобы начать выпуск.',
    },
    'Nueva campaña de cupones': {
        pt: 'Nova campanha de cupons',
        en: 'New coupon campaign',
        ru: 'Новая купонная кампания',
    },
    Campaña: { pt: 'Campanha', en: 'Campaign', ru: 'Кампания' },
    desactivada: { pt: 'desativada', en: 'deactivated', ru: 'деактивирована' },
    'Lluvia TV': { pt: 'Chuva TV', en: 'TV Rain', ru: 'ТВ-дождь' },

    // ── Tab Análisis: KPIs agnósticos de promociones ─────────────────────────
    Análisis: { pt: 'Análise', en: 'Analytics', ru: 'Аналитика' },
    Tipo: { pt: 'Tipo', en: 'Type', ru: 'Тип' },
    'Aplica a': { pt: 'Aplica a', en: 'Applies to', ru: 'Применяется к' },
    'Tipo de promoción': { pt: 'Tipo de promoção', en: 'Promotion type', ru: 'Тип акции' },
    'Evento que dispara el bono': {
        pt: 'Evento que dispara o bônus',
        en: 'Event that triggers the bonus',
        ru: 'Событие, запускающее бонус',
    },
    // Óptimos de industria (texto chico bajo cada KPI).
    'ideal ≥15%': { pt: 'ideal ≥15%', en: 'ideal ≥15%', ru: 'идеал ≥15%' },
    'sano ≤30%': { pt: 'saudável ≤30%', en: 'healthy ≤30%', ru: 'норма ≤30%' },
    'ideal ≥5x': { pt: 'ideal ≥5x', en: 'ideal ≥5x', ru: 'идеал ≥5x' },
    'ideal ≥3x': { pt: 'ideal ≥3x', en: 'ideal ≥3x', ru: 'идеал ≥3x' },
    'sano ≥90%': { pt: 'saudável ≥90%', en: 'healthy ≥90%', ru: 'норма ≥90%' },
    'ideal ≥80%': { pt: 'ideal ≥80%', en: 'ideal ≥80%', ru: 'идеал ≥80%' },
    // Dimensiones de negocio del veredicto (industria: revenue/retención/operativa).
    Ingresos: { pt: 'Receita', en: 'Revenue', ru: 'Доход' },
    Retención: { pt: 'Retenção', en: 'Retention', ru: 'Удержание' },
    Operativa: { pt: 'Operacional', en: 'Operational', ru: 'Операционная' },
    // Veredictos finales de la promo.
    'Excelente — supera los parámetros de industria': {
        pt: 'Excelente — supera os parâmetros do setor',
        en: 'Excellent — exceeds industry benchmarks',
        ru: 'Отлично — превышает отраслевые показатели',
    },
    'Saludable — dentro de los parámetros': {
        pt: 'Saudável — dentro dos parâmetros',
        en: 'Healthy — within benchmarks',
        ru: 'Норма — в пределах показателей',
    },
    'Necesita mejora — por debajo de lo esperable': {
        pt: 'Precisa melhorar — abaixo do esperado',
        en: 'Needs improvement — below expected',
        ru: 'Требует улучшения — ниже ожидаемого',
    },
    'Revisar — muy por debajo de los parámetros': {
        pt: 'Revisar — muito abaixo dos parâmetros',
        en: 'Review — well below benchmarks',
        ru: 'Проверить — значительно ниже показателей',
    },
    'Salud por dimensión': { pt: 'Saúde por dimensão', en: 'Health by dimension', ru: 'Здоровье по измерениям' },
    Activación: { pt: 'Ativação', en: 'Activation', ru: 'Активация' },
    Leverage: { pt: 'Alavancagem', en: 'Leverage', ru: 'Леверидж' },
    Wagering: { pt: 'Rollover', en: 'Wagering', ru: 'Отыгрыш' },
    'De cada 100 que reciben el bono': {
        pt: 'A cada 100 que recebem o bônus',
        en: 'Of every 100 who receive the bonus',
        ru: 'Из каждых 100, получивших бонус',
    },
    'lo usan': { pt: 'usam', en: 'use it', ru: 'используют' },
    'recargan su plata': {
        pt: 'recarregam o próprio dinheiro',
        en: 'top up their own money',
        ru: 'пополняют своими деньгами',
    },
    'se van con el bono': { pt: 'saem com o bônus', en: 'leave with the bonus', ru: 'уходят с бонусом' },
    'Costo por conversión': { pt: 'Custo por conversão', en: 'Cost per conversion', ru: 'Стоимость конверсии' },
    Conversión: { pt: 'Conversão', en: 'Conversion', ru: 'Конверсия' },
    'Costo en caja': { pt: 'Custo em caixa', en: 'Cash cost', ru: 'Затраты из кассы' },
    'Costo s/ recargado': { pt: 'Custo s/ recarregado', en: 'Cost vs topped up', ru: 'Затраты к пополнению' },
    'Fuga en caja': { pt: 'Vazamento em caixa', en: 'Cash leakage', ru: 'Утечка из кассы' },
    Indicadores: { pt: 'Indicadores', en: 'Indicators', ru: 'Показатели' },
    Cohorte: { pt: 'Coorte', en: 'Cohort', ru: 'Когорта' },
    Otorgado: { pt: 'Concedido', en: 'Granted', ru: 'Выдано' },
    Recurrencia: { pt: 'Recorrência', en: 'Recurrence', ru: 'Повторяемость' },
    inactiva: { pt: 'inativa', en: 'inactive', ru: 'неактивна' },
    'Ver análisis completo': { pt: 'Ver análise completa', en: 'View full analytics', ru: 'Полная аналитика' },
    'No hay promociones con actividad para analizar': {
        pt: 'Não há promoções com atividade para analisar',
        en: 'No promotions with activity to analyze',
        ru: 'Нет акций с активностью для анализа',
    },
    'No hay promociones con actividad': {
        pt: 'Não há promoções com atividade',
        en: 'No promotions with activity',
        ru: 'Нет акций с активностью',
    },
    'No se pudieron cargar los KPIs de promociones': {
        pt: 'Não foi possível carregar os KPIs das promoções',
        en: 'Could not load promotion KPIs',
        ru: 'Не удалось загрузить KPI акций',
    },
    // Categorías/tipos de promo (vienen de DB; se muestran crudos → traducir).
    Retencion: { pt: 'Retenção', en: 'Retention', ru: 'Удержание' },
    Adquisicion: { pt: 'Aquisição', en: 'Acquisition', ru: 'Привлечение' },
    Apuesta: { pt: 'Aposta', en: 'Bet', ru: 'Ставка' },
    Registro: { pt: 'Cadastro', en: 'Registration', ru: 'Регистрация' },

    // ── Dashboard: comparativa por sorteo (jugadas/premios/RTP) ──────────────
    'Jugadas vs Premios por sorteo': {
        pt: 'Apostas vs Prêmios por sorteio',
        en: 'Bets vs Prizes by draw',
        ru: 'Ставки и призы по тиражам',
    },
    'RTP por sorteo': { pt: 'RTP por sorteio', en: 'RTP by draw', ru: 'RTP по тиражам' },
    Jugadas: { pt: 'Apostas', en: 'Bets', ru: 'Ставки' },
    Premios: { pt: 'Prêmios', en: 'Prizes', ru: 'Призы' },
    '"Premios" es lo que ganó el jugador al momento del sorteo, aunque todavía no lo haya cobrado en caja. Puede no coincidir con el cierre del día.':
        {
            pt: '"Prêmios" é o que o jogador ganhou no momento do sorteio, mesmo que ainda não tenha sacado no caixa. Pode não bater com o fechamento do dia.',
            en: '"Prizes" is what the player won at the moment of the draw, even if not claimed at the register yet. May not match the day’s closing totals.',
            ru: '«Призы» — это то, что выиграл игрок в момент розыгрыша, даже если ещё не получил их в кассе. Может не совпадать с итогами закрытия дня.',
        },
    // ── "Minha rede" (dashboard operativo, fila Ganado vs Cobrado) ────────────
    'Cobrado en caja': { pt: 'Sacado no caixa', en: 'Claimed at register', ru: 'Получено в кассе' },
    'Ganado, pendiente de cobro': {
        pt: 'Ganho, pendente de saque',
        en: 'Won, pending claim',
        ru: 'Выиграно, ожидает получения',
    },
    Ganado: { pt: 'Ganho', en: 'Won', ru: 'Выиграно' },
    'Sin actividad por sorteo en el período': {
        pt: 'Sem atividade por sorteio no período',
        en: 'No activity by draw in the period',
        ru: 'Нет активности по тиражам за период',
    },
    'No se pudieron cargar los KPIs por sorteo': {
        pt: 'Não foi possível carregar os KPIs por sorteio',
        en: 'Could not load KPIs by draw',
        ru: 'Не удалось загрузить KPI по тиражам',
    },
    'Sin datos': { pt: 'Sem dados', en: 'No data', ru: 'Нет данных' },

    // ── Tab Tickets: promociones de tickets al portador ─────────────────────
    'Promociones de Tickets': {
        pt: 'Promoções de Tickets',
        en: 'Ticket Promotions',
        ru: 'Акции по билетам',
    },
    'Nueva promoción de ticket': {
        pt: 'Nova promoção de ticket',
        en: 'New ticket promotion',
        ru: 'Новая акция по билету',
    },
    'Editar promoción de ticket': {
        pt: 'Editar promoção de ticket',
        en: 'Edit ticket promotion',
        ru: 'Изменить акцию по билету',
    },
    'Ver plantillas': { pt: 'Ver modelos', en: 'View templates', ru: 'Показать шаблоны' },
    'Plantillas de tickets': { pt: 'Modelos de tickets', en: 'Ticket templates', ru: 'Шаблоны билетов' },
    'Activar plantilla': { pt: 'Ativar modelo', en: 'Activate template', ru: 'Активировать шаблон' },
    'Plantilla activada': { pt: 'Modelo ativado', en: 'Template activated', ru: 'Шаблон активирован' },
    'No hay promociones de tickets. Crea una con "Nueva promoción de ticket" o activa una plantilla.': {
        pt: 'Não há promoções de tickets. Crie uma com "Nova promoção de ticket" ou ative um modelo.',
        en: 'No ticket promotions. Create one with "New ticket promotion" or activate a template.',
        ru: 'Нет акций по билетам. Создайте через «Новая акция по билету» или активируйте шаблон.',
    },
    Efecto: { pt: 'Efeito', en: 'Effect', ru: 'Эффект' },
    Descuento: { pt: 'Desconto', en: 'Discount', ru: 'Скидка' },
    Mínimo: { pt: 'Mínimo', en: 'Minimum', ru: 'Минимум' },
    'Sorteo extra': { pt: 'Sorteio extra', en: 'Extra draw', ru: 'Дополнительный тираж' },
    'Apuestas gratis': { pt: 'Apostas grátis', en: 'Free bets', ru: 'Бесплатные ставки' },
    'Seguro contra cero': { pt: 'Seguro contra zero', en: 'Zero insurance', ru: 'Страховка от нуля' },
    'Multiplicador por tipo': {
        pt: 'Multiplicador por tipo',
        en: 'Multiplier by type',
        ru: 'Множитель по типу',
    },
    // Etiquetas de los tipos de efecto (select del modal)
    'Multiplicador de premio': {
        pt: 'Multiplicador de prêmio',
        en: 'Prize multiplier',
        ru: 'Множитель приза',
    },
    'Multiplicador por tipo de apuesta': {
        pt: 'Multiplicador por tipo de aposta',
        en: 'Multiplier by bet type',
        ru: 'Множитель по типу ставки',
    },
    'Bonus fijo al premio': { pt: 'Bônus fixo ao prêmio', en: 'Fixed prize bonus', ru: 'Фиксированный бонус к призу' },
    'Premio mínimo garantizado': {
        pt: 'Prêmio mínimo garantido',
        en: 'Guaranteed minimum prize',
        ru: 'Гарантированный минимальный приз',
    },

    // ── Premio variable (rueda): etiquetas, ayudas y errores del contrato ────
    // La regla que explican: el promedio tiene que quedar ESTRICTAMENTE dentro del
    // rango. Con el promedio pegado a un borde, conservarlo obliga a pagar siempre
    // ese borde y la rueda deja de ser variable.
    'Convertir en premio variable (rueda)': {
        pt: 'Transformar em prêmio variável (roleta)',
        en: 'Turn into a variable prize (wheel)',
        ru: 'Сделать приз переменным (колесо)',
    },
    'El jugador gana lo mismo en promedio, pero lo descubre girando una rueda.': {
        pt: 'O jogador ganha o mesmo em média, mas descobre girando uma roleta.',
        en: 'The player wins the same on average, but discovers it by spinning a wheel.',
        ru: 'В среднем игрок выигрывает столько же, но узнаёт сумму, вращая колесо.',
    },
    'Cantidad de premios posibles': {
        pt: 'Quantidade de prêmios possíveis',
        en: 'Number of possible prizes',
        ru: 'Количество возможных призов',
    },
    'Cuántas cifras distintas puede mostrar la rueda.': {
        pt: 'Quantos valores diferentes a roleta pode mostrar.',
        en: 'How many different amounts the wheel can show.',
        ru: 'Сколько разных сумм может показать колесо.',
    },
    'Premio mínimo': { pt: 'Prêmio mínimo', en: 'Minimum prize', ru: 'Минимальный приз' },
    'Lo menos que puede tocar. Tiene que ser MENOR que el promedio.': {
        pt: 'O mínimo que pode sair. Precisa ser MENOR que a média.',
        en: 'The least that can come up. It must be LOWER than the average.',
        ru: 'Наименьшая возможная сумма. Должна быть МЕНЬШЕ среднего.',
    },
    'Premio máximo': { pt: 'Prêmio máximo', en: 'Maximum prize', ru: 'Максимальный приз' },
    'Lo más que puede tocar. Tiene que ser MAYOR que el promedio.': {
        pt: 'O máximo que pode sair. Precisa ser MAIOR que a média.',
        en: 'The most that can come up. It must be HIGHER than the average.',
        ru: 'Наибольшая возможная сумма. Должна быть БОЛЬШЕ среднего.',
    },
    'Promedio que recibe el jugador': {
        pt: 'Média que o jogador recebe',
        en: 'Average the player receives',
        ru: 'Средняя сумма, которую получает игрок',
    },
    'Sale de la recompensa de arriba. La rueda reparte alrededor de este valor sin cambiar lo que cuesta la promoción.': {
        pt: 'Vem da recompensa acima. A roleta distribui em torno deste valor sem mudar o custo da promoção.',
        en: 'It comes from the reward above. The wheel spreads around this value without changing what the promotion costs.',
        ru: 'Берётся из награды выше. Колесо распределяет суммы вокруг этого значения, не меняя стоимость акции.',
    },
    promedio: { pt: 'média', en: 'average', ru: 'среднее' },
    'El premio mínimo tiene que ser menor que el promedio. Si nunca se paga menos, el promedio real sería mayor que el prometido.': {
        pt: 'O prêmio mínimo precisa ser menor que a média. Se nunca se paga menos, a média real ficaria acima da prometida.',
        en: 'The minimum prize must be lower than the average. If it never pays less, the real average would exceed the promised one.',
        ru: 'Минимальный приз должен быть меньше среднего. Если меньше не выплачивается никогда, реальное среднее превысит обещанное.',
    },
    'El premio máximo tiene que ser mayor que el promedio. Si nunca se paga más, el promedio real sería menor que el prometido.': {
        pt: 'O prêmio máximo precisa ser maior que a média. Se nunca se paga mais, a média real ficaria abaixo da prometida.',
        en: 'The maximum prize must be higher than the average. If it never pays more, the real average would fall below the promised one.',
        ru: 'Максимальный приз должен быть больше среднего. Если больше не выплачивается никогда, реальное среднее окажется ниже обещанного.',
    },
    'El premio mínimo tiene que ser menor que el máximo.': {
        pt: 'O prêmio mínimo precisa ser menor que o máximo.',
        en: 'The minimum prize must be lower than the maximum.',
        ru: 'Минимальный приз должен быть меньше максимального.',
    },
    'Los premios tienen que ser mayores que cero.': {
        pt: 'Os prêmios precisam ser maiores que zero.',
        en: 'Prizes must be greater than zero.',
        ru: 'Призы должны быть больше нуля.',
    },
    'Escribí un número válido en cada premio.': {
        pt: 'Escreva um número válido em cada prêmio.',
        en: 'Enter a valid number for each prize.',
        ru: 'Введите корректное число для каждого приза.',
    },
    'La cantidad de premios posibles tiene que ser un número entero de 1 o más.': {
        pt: 'A quantidade de prêmios possíveis precisa ser um número inteiro de 1 ou mais.',
        en: 'The number of possible prizes must be a whole number of 1 or more.',
        ru: 'Количество возможных призов должно быть целым числом от 1.',
    },
    'Con importes tan chicos no caben dos premios distintos: se pagará el importe fijo.': {
        pt: 'Com valores tão pequenos não cabem dois prêmios diferentes: será pago o valor fixo.',
        en: 'With amounts this small there is no room for two different prizes: the fixed amount will be paid.',
        ru: 'При таких малых суммах два разных приза не помещаются: будет выплачена фиксированная сумма.',
    },
    'Este tipo de recompensa no admite premio variable.': {
        pt: 'Este tipo de recompensa não aceita prêmio variável.',
        en: 'This reward type does not support a variable prize.',
        ru: 'Этот тип награды не поддерживает переменный приз.',
    },
    'La configuración del premio variable está corrupta. Desactivala y volvé a cargarla.': {
        pt: 'A configuração do prêmio variável está corrompida. Desative e configure novamente.',
        en: 'The variable prize configuration is corrupted. Turn it off and set it up again.',
        ru: 'Настройка переменного приза повреждена. Отключите её и задайте заново.',
    },
    'Revisá la configuración del premio variable.': {
        pt: 'Revise a configuração do prêmio variável.',
        en: 'Review the variable prize configuration.',
        ru: 'Проверьте настройку переменного приза.',
    },
    'Completá el premio mínimo y el máximo, o desactivá el premio variable.': {
        pt: 'Preencha o prêmio mínimo e o máximo, ou desative o prêmio variável.',
        en: 'Fill in the minimum and maximum prize, or turn off the variable prize.',
        ru: 'Укажите минимальный и максимальный приз или отключите переменный приз.',
    },
    'Esta promoción tiene una configuración de premio variable imposible: se está pagando el importe fijo.': {
        pt: 'Esta promoção tem uma configuração de prêmio variável impossível: está sendo pago o valor fixo.',
        en: 'This promotion has an impossible variable prize setup: the fixed amount is being paid.',
        ru: 'У этой акции невозможная настройка переменного приза: выплачивается фиксированная сумма.',
    },
    'Desactivar el premio variable': {
        pt: 'Desativar o prêmio variável',
        en: 'Turn off the variable prize',
        ru: 'Отключить переменный приз',
    },
    'Corregir el rango': { pt: 'Corrigir o intervalo', en: 'Fix the range', ru: 'Исправить диапазон' },
    // Etiquetas de campos del efecto
    'Multiplicador (ej. 1.5)': {
        pt: 'Multiplicador (ex. 1.5)',
        en: 'Multiplier (e.g. 1.5)',
        ru: 'Множитель (напр. 1.5)',
    },
    'Multiplicadores por tipo': {
        pt: 'Multiplicadores por tipo',
        en: 'Multipliers by type',
        ru: 'Множители по типу',
    },
    'Monto del bonus': { pt: 'Valor do bônus', en: 'Bonus amount', ru: 'Сумма бонуса' },
    'Monto mínimo': { pt: 'Valor mínimo', en: 'Minimum amount', ru: 'Минимальная сумма' },
    'Cantidad de sorteos extra': {
        pt: 'Quantidade de sorteios extra',
        en: 'Number of extra draws',
        ru: 'Количество доп. тиражей',
    },
    'Monto de descuento': { pt: 'Valor do desconto', en: 'Discount amount', ru: 'Сумма скидки' },
    'Porcentaje de descuento': { pt: 'Percentual de desconto', en: 'Discount percentage', ru: 'Процент скидки' },
    'Cantidad de apuestas gratis': {
        pt: 'Quantidade de apostas grátis',
        en: 'Number of free bets',
        ru: 'Количество бесплатных ставок',
    },
    'Este efecto no necesita parámetros.': {
        pt: 'Este efeito não precisa de parâmetros.',
        en: 'This effect needs no parameters.',
        ru: 'Этому эффекту не нужны параметры.',
    },
    'JSON: tipo de apuesta → multiplicador.': {
        pt: 'JSON: tipo de aposta → multiplicador.',
        en: 'JSON: bet type → multiplier.',
        ru: 'JSON: тип ставки → множитель.',
    },
    // Formulario
    'Texto impreso en el tiquete': {
        pt: 'Texto impresso no tíquete',
        en: 'Text printed on the ticket',
        ru: 'Текст на билете',
    },
    'Texto que se imprime en el tiquete físico (58mm)': {
        pt: 'Texto impresso no tíquete físico (58mm)',
        en: 'Text printed on the physical ticket (58mm)',
        ru: 'Текст, печатаемый на физическом билете (58мм)',
    },
    'Nombre visible de la promoción': {
        pt: 'Nome visível da promoção',
        en: 'Visible promotion name',
        ru: 'Отображаемое имя акции',
    },
    'Descripción interna (opcional)': {
        pt: 'Descrição interna (opcional)',
        en: 'Internal description (optional)',
        ru: 'Внутреннее описание (необязательно)',
    },
    'Solo letras, números, guion y guion bajo.': {
        pt: 'Apenas letras, números, hífen e sublinhado.',
        en: 'Only letters, numbers, hyphen and underscore.',
        ru: 'Только буквы, цифры, дефис и подчёркивание.',
    },
    'Heredable a nodos descendientes': {
        pt: 'Herdável para nós descendentes',
        en: 'Inheritable to descendant nodes',
        ru: 'Наследуется дочерними узлами',
    },
    // Validaciones y mensajes
    'El código es obligatorio': { pt: 'O código é obrigatório', en: 'Code is required', ru: 'Код обязателен' },
    'El nombre es obligatorio': { pt: 'O nome é obrigatório', en: 'Name is required', ru: 'Имя обязательно' },
    'El texto impreso en el tiquete es obligatorio': {
        pt: 'O texto impresso no tíquete é obrigatório',
        en: 'The text printed on the ticket is required',
        ru: 'Текст на билете обязателен',
    },
    'Tipo de efecto inválido': { pt: 'Tipo de efeito inválido', en: 'Invalid effect type', ru: 'Неверный тип эффекта' },
    'Completa al menos un campo del efecto': {
        pt: 'Preencha ao menos um campo do efeito',
        en: 'Fill at least one effect field',
        ru: 'Заполните хотя бы одно поле эффекта',
    },
    'Ingresa los multiplicadores por tipo (JSON)': {
        pt: 'Insira os multiplicadores por tipo (JSON)',
        en: 'Enter the multipliers by type (JSON)',
        ru: 'Введите множители по типу (JSON)',
    },
    'El JSON de multiplicadores por tipo no es válido': {
        pt: 'O JSON de multiplicadores por tipo não é válido',
        en: 'The multipliers-by-type JSON is not valid',
        ru: 'JSON множителей по типу недействителен',
    },
    'Falta el campo:': { pt: 'Falta o campo:', en: 'Missing field:', ru: 'Не заполнено поле:' },
    'Valor inválido en:': { pt: 'Valor inválido em:', en: 'Invalid value in:', ru: 'Неверное значение в:' },
    '¿Eliminar la promoción de ticket': {
        pt: 'Excluir a promoção de ticket',
        en: 'Delete the ticket promotion',
        ru: 'Удалить акцию по билету',
    },
    'Promoción creada': { pt: 'Promoção criada', en: 'Promotion created', ru: 'Акция создана' },
    'Promoción actualizada': { pt: 'Promoção atualizada', en: 'Promotion updated', ru: 'Акция обновлена' },
    Tickets: { pt: 'Tickets', en: 'Tickets', ru: 'Билеты' },
    'Ej.': { pt: 'Ex.', en: 'e.g.', ru: 'напр.' },
    'Explicación para el jugador': {
        pt: 'Explicação para o jogador',
        en: 'Player explanation',
        ru: 'Объяснение для игрока',
    },
    'Explica cómo funciona, qué debe hacer y cualquier condición importante.': {
        pt: 'Explique como funciona, o que deve ser feito e qualquer condição importante.',
        en: 'Explain how it works, what must be done, and any important conditions.',
        ru: 'Объясните механику, необходимые действия и важные условия.',
    },
    'Se mostrará completa al abrir el detalle en Mis promociones. Los montos y progresos se calculan automáticamente.':
        {
            pt: 'Será exibida por completo ao abrir o detalhe em Minhas promoções. Valores e progressos são calculados automaticamente.',
            en: 'It will be shown in full in My promotions details. Amounts and progress are calculated automatically.',
            ru: 'Полный текст будет показан в деталях раздела «Мои акции». Суммы и прогресс рассчитываются автоматически.',
        },
    'Vista del jugador': { pt: 'Visão do jogador', en: 'Player view', ru: 'Вид игрока' },
    'Previsualización de la promoción': {
        pt: 'Prévia da promoção',
        en: 'Promotion preview',
        ru: 'Предпросмотр акции',
    },
    'Idioma de la vista previa': {
        pt: 'Idioma da prévia',
        en: 'Preview language',
        ru: 'Язык предпросмотра',
    },
    'Datos de progreso de ejemplo': {
        pt: 'Dados de progresso de exemplo',
        en: 'Sample progress data',
        ru: 'Пример данных прогресса',
    },
    'Así aparecerá en Mis promociones': {
        pt: 'Assim aparecerá em Minhas promoções',
        en: 'How it appears in My promotions',
        ru: 'Так отображается в «Моих акциях»',
    },
    'Así se entregará': { pt: 'Assim será entregue', en: 'How it will be delivered', ru: 'Так будет выдано' },
    'Título antes de revelar': {
        pt: 'Título antes de revelar',
        en: 'Title before reveal',
        ru: 'Заголовок до раскрытия',
    },
    'Texto antes de revelar': {
        pt: 'Texto antes de revelar',
        en: 'Text before reveal',
        ru: 'Текст до раскрытия',
    },
    'Título al entregar': { pt: 'Título ao entregar', en: 'Delivery title', ru: 'Заголовок при выдаче' },
    'Texto al entregar': { pt: 'Texto ao entregar', en: 'Delivery text', ru: 'Текст при выдаче' },
    'Textos de la experiencia': {
        pt: 'Textos da experiência',
        en: 'Experience copy',
        ru: 'Тексты Experience',
    },
    'Opcionales. La experiencia usa sus textos propios cuando quedan vacíos.': {
        pt: 'Opcionais. A experiência usa seus próprios textos quando ficam vazios.',
        en: 'Optional. The Experience uses its own copy when these are empty.',
        ru: 'Необязательно. При пустых полях Experience использует собственные тексты.',
    },
    'Traducciones opcionales': {
        pt: 'Traduções opcionais',
        en: 'Optional translations',
        ru: 'Дополнительные переводы',
    },
    'Sin presentación adicional': {
        pt: 'Sem apresentação adicional',
        en: 'No additional presentation',
        ru: 'Без дополнительной презентации',
    },
    'Configuración existente': {
        pt: 'Configuração existente',
        en: 'Existing configuration',
        ru: 'Существующая настройка',
    },
    Recomendada: { pt: 'Recomendada', en: 'Recommended', ru: 'Рекомендуется' },
    'La recompensa se acredita sin abrir una experiencia.': {
        pt: 'A recompensa é creditada sem abrir uma experiência.',
        en: 'The reward is credited without opening an Experience.',
        ru: 'Награда начисляется без запуска Experience.',
    },
    'La recompensa se acreditará sin abrir una experiencia.': {
        pt: 'A recompensa será creditada sem abrir uma experiência.',
        en: 'The reward will be credited without opening an Experience.',
        ru: 'Награда будет начислена без запуска Experience.',
    },
    'Recompensa por definir': { pt: 'Recompensa a definir', en: 'Reward not set', ru: 'Награда не задана' },
    'Recompensa configurada': {
        pt: 'Recompensa configurada',
        en: 'Configured reward',
        ru: 'Настроенная награда',
    },
    'Nombre de la promoción': { pt: 'Nome da promoção', en: 'Promotion name', ru: 'Название акции' },
    'Aquí aparecerá la explicación configurada para el jugador.': {
        pt: 'A explicação configurada para o jogador aparecerá aqui.',
        en: 'The explanation configured for the player will appear here.',
        ru: 'Здесь появится объяснение, настроенное для игрока.',
    },
    Logro: { pt: 'Conquista', en: 'Achievement', ru: 'Достижение' },
    Promoción: { pt: 'Promoção', en: 'Promotion', ru: 'Акция' },
    Recibirás: { pt: 'Você receberá', en: 'You will receive', ru: 'Вы получите' },
    'progreso de ejemplo': { pt: 'progresso de exemplo', en: 'sample progress', ru: 'пример прогресса' },
    Antes: { pt: 'Antes', en: 'Before', ru: 'До' },
    'Al entregar': { pt: 'Ao entregar', en: 'On delivery', ru: 'При выдаче' },
    'Fallback por plataforma': {
        pt: 'Fallback por plataforma',
        en: 'Platform fallback',
        ru: 'Резервный вариант платформы',
    },
    'Textos de esta entrega': {
        pt: 'Textos desta entrega',
        en: 'Copy for this delivery',
        ru: 'Тексты этой выдачи',
    },
};
